import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IFormStepProps } from '../PageWrapper/PageWrapper';
import ResultScreen from '../../Components/ResultScreen/ResultScreen';
import Constants, { COUNTRY_CODE } from '../../../Utils/Constants';
import useStepContext from '../../Hooks/useStepContext';
import ISessionManager from '../../../Business/ISessionManager';
import DI from '../../../Utils/DI';
import Utils from '../../../Utils/Utils';
import IMsisdn from '../EnterPhoneNumber/enter-phone-number-types';
import IUserManager from '../../../Business/UserManager/IUserManager';
import IDataManager from '../../../Business/IDataManager';

const ValidateOtpExisting: FC<IFormStepProps> = ({ nextStepHandler }) => {
    const { t } = useTranslation();
    const sessionManager: ISessionManager = DI.get('SessionManager');
    const isAgentLogged = useMemo(() => sessionManager?.getSession()?.getIsValid(), []);
    const dataManager: IDataManager = DI.get('DataManager');
    const userManager: IUserManager = dataManager.convertToUserManager();

    const msisdn : IMsisdn = {
        input: '',
        isValid: true
    };

    return (
        <ResultScreen
            title={t('validatePhoneNumber.liteAccount')}
            description=""
            actionText={t('general.continue')}
            success
            showActionButton
            actionFn={() => {
                if (isAgentLogged) {
                    nextStepHandler({
                        ...Constants.FORM_STEPS.VALIDATE_OTP,
                        PROPS: {
                            title: t('validatePhoneNumber.validateCustomerMsisdn'),
                            description: `${t('validatePhoneNumber.sentCode')} 
                                ${t('validatePhoneNumber.to')} ${COUNTRY_CODE.code}
                               ${Utils.msisdnFormatter(userManager.getMsisdn())}.`,
                            onOtpSuccess: () => {
                                nextStepHandler({
                                    ...Constants.FORM_STEPS.PERSONAL_DOCUMENTS,
                                    TITLE: isAgentLogged ? 'customerDocuments' : Constants.FORM_STEPS.PERSONAL_DOCUMENTS.TITLE
                                });
                            }
                        }
                    });
                } else {
                    nextStepHandler({
                        ...Constants.FORM_STEPS.PERSONAL_DOCUMENTS,
                        TITLE: isAgentLogged ? 'customerDocuments' : Constants.FORM_STEPS.PERSONAL_DOCUMENTS.TITLE
                    });
                }
            }}
        />
    );
};

export default ValidateOtpExisting;
